import styled from 'styled-components'
import Image from 'next/image'

import { mq, sizes } from '../../theme'
import ActionButton from '../ActionButton'
import Link from '../Link'
import Breadcrumb from '../Breadcrumb'

export const AdsIntro = styled.div``

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 3.5rem;

  @media ${mq(sizes.desktop)} {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  @media ${mq(sizes.scoping)} {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
`

export const Container = styled.div`
  @media ${mq(sizes.desktop)} {
    grid-area: 1 / 1 / 2 / 3;
  }
`

export const Title = styled.h1`
  ${({ theme }) => theme.textStyles.firaSans4Xl};
  line-height: 1.2;
  color: ${({ theme }) => theme.colors.bluePrimary};
  margin: 0;

  @media ${mq(sizes.tablet)} {
    ${({ theme }) => theme.textStyles.firaSans5Xl};
    line-height: 1.2;
  }
`

export const BreadcrumbElement = styled(Breadcrumb)`
  margin-bottom: 2.8rem;
  li:nth-last-child(2) span {
    ${({ theme }) => theme.textStyles.montserratTextBaseBold};
  }
  li:last-child > * {
    ${({ theme }) => theme.textStyles.montserratTextBase};
  }
`

export const Text = styled.p`
  ${({ theme }) => theme.textStyles.montserratXl};
  color: ${({ theme }) => theme.colors.blueSecondaryBis};
`

export const HelpText = styled.p`
  ${({ theme }) => theme.textStyles.montserratXs};
  color: ${({ theme }) => theme.colors.blueSecondaryBis};
  margin-top: 2rem;
`

export const MapContainer = styled.div`
  @media ${mq(sizes.desktop)} {
    grid-area: 1 / 3 / 3 / 4;
    width: 36.5rem;
  }
`

export const Map = styled(Image)`
  border-radius: 2rem;
  overflow: hidden;
  width: 100%;
`

export const AddressWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.bluePrimary};
  margin-top: -1.5rem;
  padding: 3.9rem 3rem 2.4rem 3rem;
  border-bottom-right-radius: 2rem;
  border-bottom-left-radius: 2rem;
`

export const Address = styled.p`
  color: ${({ theme }) => theme.colors.pureWhite};
  ${({ theme }) => theme.textStyles.montserratTextBase};
`

export const ViewItineraryLink = styled(Link)`
  color: ${({ theme }) => theme.colors.greenAccent};
  text-decoration: underline;
  ${({ theme }) => theme.textStyles.montserratXs};
  margin-top: 1rem;
`

export const AdsInformation = styled.div`
  ${({ theme }) => theme.textStyles.montserratTextBase};
  color: ${({ theme }) => theme.colors.blueSecondaryBis};
  font-style: italic;

  @media ${mq(sizes.desktop)} {
    grid-area: 2 / 1 / 3 / 2;
    align-self: flex-end;
  }
`

export const AdsInformationParagraph = styled.p``

export const ButtonContainer = styled.div`
  width: 100%;

  @media ${mq(sizes.desktop)} {
    grid-area: 2 / 2 / 3 / 3;
    align-self: flex-end;
  }
`

export const Button = styled(ActionButton)`
  width: max-content;
  margin: auto;
  display: block;

  @media ${mq(sizes.desktop)} {
    margin: 0 0 0 auto;
  }
`

export const Separator = styled.div`
  background-image: repeating-linear-gradient(
      0deg,
      ${({ theme }) => theme.colors.greyContour},
      ${({ theme }) => theme.colors.greyContour} 1rem,
      transparent 1rem,
      transparent 1.6rem,
      ${({ theme }) => theme.colors.greyContour} 1.6rem
    ),
    repeating-linear-gradient(
      90deg,
      ${({ theme }) => theme.colors.greyContour},
      ${({ theme }) => theme.colors.greyContour} 1rem,
      transparent 1rem,
      transparent 1.6rem,
      ${({ theme }) => theme.colors.greyContour} 1.6rem
    ),
    repeating-linear-gradient(
      180deg,
      ${({ theme }) => theme.colors.greyContour},
      ${({ theme }) => theme.colors.greyContour} 1rem,
      transparent 1rem,
      transparent 1.6rem,
      ${({ theme }) => theme.colors.greyContour} 1.6rem
    ),
    repeating-linear-gradient(
      270deg,
      ${({ theme }) => theme.colors.greyContour},
      ${({ theme }) => theme.colors.greyContour} 1rem,
      transparent 1rem,
      transparent 1.6rem,
      ${({ theme }) => theme.colors.greyContour} 1.6rem
    );
  background-size: 0, 0, 2px 100%, 100% 2px;
  background-position: 0 0, 0 0, 100% 0, 0 100%;
  background-repeat: no-repeat;
  height: 0.2rem;
  width: 100%;
  margin-top: 2.9rem;
`
